import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { ChevronDown, HelpCircle } from 'lucide-react';
import '../../../assets/styles/customer/layout/PricingFAQSection.css';

const PricingFAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      id: 1,
      question: 'Can I switch plans anytime?',
      answer: 'Yes, you can upgrade or downgrade your plan at any time. Changes take effect immediately, and billing is prorated.'
    },
    {
      id: 2,
      question: 'Is there a contract or commitment?',
      answer: 'No contracts! All plans are month-to-month. Cancel anytime without any penalties.'
    },
    {
      id: 3,
      question: 'What payment methods do you accept?',
      answer: 'We accept all major credit cards, debit cards, JazzCash, EasyPaisa, and bank transfers for annual plans.'
    },
    {
      id: 4,
      question: 'Do you offer discounts for annual billing?',
      answer: 'Yes! Save 20% when you choose annual billing on any paid plan.'
    },
    {
      id: 5,
      question: 'What happens if I exceed my customer limit?',
      answer: "We'll notify you when you're approaching your limit. You can easily upgrade to accommodate more customers."
    },
    {
      id: 6,
      question: 'Can I get a refund if I am not satisfied?',
      answer: 'Yes! We offer a 30-day money-back guarantee on all paid plans. No questions asked.'
    },
    {
      id: 7,
      question: 'Is my data secure?',
      answer: 'Absolutely! We use industry-standard encryption and security measures to protect your data. Your information is safe with us.'
    },
    {
      id: 8,
      question: 'Do you offer customer support?',
      answer: 'Yes! All plans include email support. Premium plans get dedicated priority support with faster response times.'
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="pricing-faq-section">
      
      {/* Floating Background Elements */}
      <div className="faq-floating-elements">
        <div className="faq-float-bottle bottle-1">🥛</div>
        <div className="faq-float-bottle bottle-2">🥛</div>
        <div className="faq-float-bottle bottle-3">🥛</div>
      </div>

      {/* Wavy Background */}
      <div className="faq-wave-bg">
        <svg className="faq-wave top-wave" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path 
            fill="rgba(62, 150, 231, 0.04)" 
            d="M0,128L48,138.7C96,149,192,171,288,165.3C384,160,480,128,576,128C672,128,768,160,864,165.3C960,171,1056,149,1152,133.3C1248,117,1344,107,1392,101.3L1440,96L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
          ></path>
        </svg>
        <svg className="faq-wave bottom-wave" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path 
            fill="rgba(76, 175, 80, 0.03)" 
            d="M0,224L48,213.3C96,203,192,181,288,181.3C384,181,480,203,576,213.3C672,224,768,224,864,213.3C960,203,1056,181,1152,186.7C1248,192,1344,224,1392,240L1440,256L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          ></path>
        </svg>
      </div>

      {/* Decorative Icons */}
      <div className="faq-decorative-icons">
        <div className="faq-icon-float icon-1">
          <HelpCircle size={32} strokeWidth={1.5} />
        </div>
        <div className="faq-icon-float icon-2">
          <HelpCircle size={28} strokeWidth={1.5} />
        </div>
      </div>

      <Container>
        
        {/* Section Header */}
        <div className="faq-header text-center">
          <h2 className="faq-title">
            Frequently Asked <span className="faq-title-highlight">Questions</span>
          </h2>
          <p className="faq-subtitle">
            Everything you need to know about our pricing
          </p>
        </div>

        {/* FAQ Grid */}
        <Row className="justify-content-center">
          <Col lg={10} xl={8}>
            <div className="faq-accordion">
              {faqs.map((faq, index) => (
                <div 
                  key={faq.id}
                  className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                  style={{ animationDelay: `${index * 0.05}s` }}
                >
                  <button 
                    className="faq-question"
                    onClick={() => toggleFAQ(index)}
                  >
                    <span className="faq-question-text">{faq.question}</span>
                    <div className={`faq-icon ${activeIndex === index ? 'rotated' : ''}`}>
                      <ChevronDown size={24} />
                    </div>
                  </button>
                  
                  <div className={`faq-answer ${activeIndex === index ? 'show' : ''}`}>
                    <p>{faq.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>

        {/* Still Have Questions CTA */}
        <div className="faq-cta text-center">
          <h3 className="faq-cta-title">Still have questions?</h3>
          <p className="faq-cta-text">
            Can't find the answer you're looking for? Our support team is here to help.
          </p>
          <button className="faq-contact-btn">
            <HelpCircle size={20} className="me-2" />
            Contact Support
          </button>
        </div>

      </Container>
    </section>
  );
};

export default PricingFAQSection;